import Marquee from "react-fast-marquee";

const words = [
  "Front of House",
  "Back Office",
  "Intelligence",
  "Bridge",
  "Node",
  "Connect",
];

export default function BrandMarquee() {
  return (
    <section
      data-testid="brand-marquee"
      className="py-16 md:py-24 border-t border-verlo/10 overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display font-light text-4xl md:text-6xl lg:text-7xl text-verlo/25 px-8 md:px-14">
              {w}
            </span>
            <span className="text-brass text-2xl md:text-4xl">·</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
